<template>
  <div id="notifications">
    <div class="alert alert-success" v-for="(item, key) in success" :key = "key">
      <div class="container">
        <button
            type="button"
            aria-hidden="true"
            class="close"
            @click="event => removeNotify(event, 'alert-success')"
        >
          <md-icon>clear</md-icon>
        </button>
        <div class="alert-icon">
          <md-icon>check</md-icon>
        </div>
        {{item}}
      </div>
    </div>
  </div>
<!--  <div>
    <b-alert v-for="(item, key) in success" :key = "key" variant="success" show>
      {{item}}
    </b-alert>
  </div>-->
</template>

<script>
export default {
  name: "Success",
  props: ['success'],
  methods: {
    removeNotify(e, notifyClass) {
      var target = e.target;
      while (target.className.indexOf(notifyClass) === -1) {
        target = target.parentNode;
      }
      return target.parentNode.removeChild(target);
    }
  },

}
</script>

<style scoped>

</style>